module.exports = __webpack_public_path__ + "static/media/iv_esign.ac5c2f63.svg";